module.exports = __webpack_public_path__ + "static/media/2.5e6aeb4e.png";